import { render, staticRenderFns } from "./line.vue?vue&type=template&id=2f908c3b&scoped=true"
import script from "./line.vue?vue&type=script&lang=js"
export * from "./line.vue?vue&type=script&lang=js"
import style0 from "./line.vue?vue&type=style&index=0&id=2f908c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f908c3b",
  null
  
)

export default component.exports